
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'PanNeuTumor',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GD/PanNeuTumor.vue